// extracted by mini-css-extract-plugin
export default {"section":"AboutMeText_section__BMKtg","backgroundText":"AboutMeText_backgroundText__rCK+H","topic":"AboutMeText_topic__89fG4"};